'use client';
import { frontendEnv } from '@/lib/api/env';
import jsCookies from 'js-cookie';
import { stringFromBase64URL, stringToBase64URL } from '@supabase/ssr';
import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
    frontendEnv.NEXT_PUBLIC_SUPABASE_URL,
    frontendEnv.NEXT_PUBLIC_SUPABASE_ANON_KEY,
    {
        auth: {
            storage: {
                //...localStorageAdapter,
                getItem: (key: string) => {
                    let cres = jsCookies.get(key);
                    if (!cres) return null;
                    if (cres.startsWith('base64-')) cres = cres.substring(7);
                    return stringFromBase64URL(cres);
                },
                setItem: (key: string, value: string) => {
                    jsCookies.set(key, `base64-${stringToBase64URL(value)}`);
                },
                removeItem: (key: string) => {
                    jsCookies.remove(key);
                },
                isServer: false,
            },
        },
    },
);
